import { useSite } from "@/lib/site";
import { useSeo } from "@/lib/seo";
import { Hero } from "@/components/home/Hero";
import { SelectedWork } from "@/components/home/SelectedWork";
import { Capabilities } from "@/components/home/Capabilities";
import { Highlight } from "@/components/home/Highlight";
import { BuildSelector } from "@/components/home/BuildSelector";
import { Opportunities } from "@/components/home/Opportunities";
import { KindWords } from "@/components/home/KindWords";

export default function Home() {
  const { settings } = useSite();
  useSeo();
  if (!settings) return null;
  return (
    <div data-testid="home-page">
      <Hero settings={settings} />
      <SelectedWork />
      <KindWords />
      <Capabilities />
      <Highlight id="custom-software" number="03" data={settings.custom_software} ctaType="custom-software" />
      <div className="container-x"><div className="h-px bg-line/10" /></div>
      <Highlight id="ai-technology" number="04" data={settings.ai_section} frame="laptop" ctaType="ai-automation" reverse />
      <BuildSelector />
      <Opportunities settings={settings} />
    </div>
  );
}
